angular.module("ainapp")
    .controller("priceChartController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Price Chart";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Units == [];
            MainService.UnitsInDropdown().then(function (response) {
                $scope.Units = response.data;
            });

            $scope.CostCenters == [];
            MainService.CostCentersInTreeList().then(function (response) {
                if (response.data) {
                    $scope.CostCenters = response.data;
                }
            }, function (err) {
                toastr.error("Network Error");
            });

            $scope.Init = function () {
                $scope.chart = {
                    SellPrice: 0,
                    Cost: 0,
                    PurchasePrice: 0,
                    Commission: 0,
                    Field21Amount: 0,
                    Field22Amount: 0,
                    Field23Amount: 0,
                    Field24Amount: 0,
                    Field25Amount: 0,
                    ProductId: "",
                    AccountMasterId: "",
                    CostCenterParentId: "",
                    CostCenterId: "",
                    IsMandatory: true,
                    PriceChartDetails: [],
                }

                $scope.load = 0;
                $scope.CostChildren = [];
                $scope.selectedCost = {};

            }
            $scope.Init();

            $scope.changeGroup = function () {
                angular.forEach($scope.CostCenters, function (e) {
                    if ($scope.chart.CostCenterParentId == e.Id) {
                        $scope.CostChildren = e.Childrens;
                        $scope.selectedCost = e;
                    }
                })
            }

            $scope.addCost = function () {
                if ($scope.chart.CostCenterParentId == "") {
                    toastr.warning("Select  Group");
                } else if ($scope.chart.CostCenterId == "") {
                    toastr.warning("Select  Cost Center");
                } else {
                    var data = {
                        CostCenterParentId: $scope.chart.CostCenterParentId,
                        CostCenterId: $scope.chart.CostCenterId,
                        IsMandatory: $scope.chart.IsMandatory,
                    }

                    data.CostCenterParent = {};
                    data.CostCenterParent.Name = $scope.selectedCost.Name;
                    data.CostCenter = {};
                    angular.forEach($scope.selectedCost.Childrens, function (e) {
                        if ($scope.chart.CostCenterId == e.Id) {
                            data.CostCenter.Name = e.Name;
                        }
                    })

                    $scope.chart.PriceChartDetails.push(data);

                    $scope.chart.CostCenterParentId = "";
                    $scope.chart.CostCenterId = "";
                    $scope.chart.IsMandatory = true;


                }
            }


            $scope.CustomerAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.CustomerInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 5
            };

            $scope.CustomerAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.chart.AccountMaster = {};
                    $scope.chart.AccountMaster = data;
                    $scope.chart.AccountMasterId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.CustomerAutocompleteDataSource
            };

            $scope.ProductAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.productInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 5
            };

            $scope.ProductAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.chart.Product = {};
                    $scope.chart.Product = data;
                    $scope.chart.ProductId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.ProductAutocompleteDataSource
            };



            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        MainService.PriceChartInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            SellPrice: {
                                type: "number",
                                editable: false,
                            },
                            Cost: {
                                type: "number",
                                editable: false,
                            },
                            PurchasePrice: {
                                type: "number",
                                editable: false,
                            },
                            Commission: {
                                type: "number",
                                editable: false,
                            },
                            "Product.Name": {
                                type: "string",
                                editable: false,
                            },
                            "AccountMaster.Name": {
                                type: "string",
                                editable: false,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [

                    {
                        field: "Product.Name",
                        title: "Product",
                        },
                    {
                        field: "AccountMaster.Name",
                        title: "Account",
                        },
                    {
                        field: "SellPrice",
                        title: "Sell Price",
                        },
                    {
                        field: "Cost",
                        title: "Cost",
                        },
                    {
                        field: "PurchasePrice",
                        title: "Purchase Price",
                        },
                    {
                        field: "Commission",
                        title: "Commission",
                        },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccType(dataItem)'></button>  ",
                        width: '80px'
                        },
                    ],
            };

            $scope.Update = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.sync();
            }
            $scope.Cancel = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.cancelChanges();
            }

            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }



            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.DeletePriceChart($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#deleteModal').modal('hide');
                        toastr.success("Deleted");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = 0;
                    $.LoadingOverlay("hide");

                });
            }

            $scope.Edit = function (data) {


                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.PriceChartById(data.Id).then(function (response) {
                    if (response.data) {
                        $scope.chart = response.data;
                    } else {
                        toastr.error("Error");
                    }
                    $.LoadingOverlay("hide");

                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });
            }


            $scope.AddData = function () {
                if ($scope.chart.ProductId == "") {
                    toastr.warning("Select  Product");
                }
                //                else if ($scope.chart.SellPrice == 0) {
                //                    toastr.warning("Enter Sell Price");
                //                } else if ($scope.chart.PurchasePrice == 0) {
                //                    toastr.warning("Enter Purchase Price");
                //                } else if ($scope.chart.PriceChartDetails.length <= 0) {
                //                    toastr.warning("Add Cost Centers To List");
                //                } 
                else {

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.AddPriceChart($scope.chart).then(function (response) {
                        if (response.data) {
                            $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                            toastr.success("Success");
                            $scope.Init();
                        } else {
                            toastr.error("Error");
                        }
                        $.LoadingOverlay("hide");

                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    });
                }
            }

        }])
